import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSectionWithRetry } from '@/lib/scrollToSection.js';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return undefined;
    }

    const id = hash.slice(1);
    if (!id) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return undefined;
    }

    return scrollToSectionWithRetry(id, { behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
